'use client'

import { usePathname } from 'next/navigation'
import TopBar from './TopBar'

export default function TopBarRouteGate() {
  const pathname = usePathname()
  const isTmaAuto = pathname === '/tma/auto' || pathname?.startsWith('/tma/auto/')
  if (isTmaAuto) return null
  return <TopBar />
}
